import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff34e7d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.t('me.yqhy'),
      "left-arrow": "",
      fixed: "",
      "z-index": "99",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router)))
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "bg",
        src: $setup.friendsBg,
        alt: ""
      }, null, 8 /* PROPS */, _hoisted_2),
      _createElementVNode("img", {
        class: "btn",
        src: $setup.invitebtn,
        alt: "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.copyclsaa('btn', $setup.downurl)))
      }, null, 8 /* PROPS */, _hoisted_3)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}